if (!customElements.get("category-quick-links")) {
  class CategoryQuickLinks extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container",
      };
      this.swiperLoading = false;
    }

    connectedCallback() {
      this.slider = this.querySelector(this.selectors.swiper);

      if (!this.slider) {
        return null;
      }

      if (this.hasAttribute("data-native-scroll")) {
        return;
      }

      this.addListeners();

      if ("IntersectionObserver" in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.observer.disconnect();
              this.loadSwiper();
            }
          },
          { rootMargin: "200px 0px" }
        );
        this.observer.observe(this);
      } else {
        this.loadSwiper();
      }
    }

    loadSwiper() {
      if (this.swiperLoading) return;
      this.swiperLoading = true;

      if (customElements.get("swiper-container")) {
        this.initSlider();
        return;
      }

      const src = this.dataset.swiperSrc;
      if (!src) return;

      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        existing.addEventListener("load", () => this.initSlider(), { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.addEventListener("load", () => this.initSlider(), { once: true });
      document.head.appendChild(script);
    }

    initSlider() {
      if (!this.slider || this.slider.swiper) return;

      let inlineOptions = this.slider.dataset.options;

      if (inlineOptions) {
        inlineOptions = JSON.parse(inlineOptions);
        if (inlineOptions.mobileSpaceBetween) {
          let mobileSpaceBetween = {
            breakpoints: {
              750: {
                spaceBetween: inlineOptions.mobileSpaceBetween,
              },
            },
          };
          Object.assign(inlineOptions, mobileSpaceBetween);
        }
      }

      this.swiperParams = {
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
        injectStyles: [
          ":host .swiper-button-next, :host .swiper-button-prev { margin-top: -40px; } :host .swiper-button-disabled { display: none }",
        ],
        scrollbar: {
          draggable: true,
          hide: false,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        on: {
          init() {
            this.hostEl.classList.add("swiper-initialized");
          },
        },
        ...inlineOptions,
      };

      Object.assign(this.slider, this.swiperParams);

      this.slider.initialize();
    }

    addListeners() {
      document.addEventListener("shopify:section:reorder", () => this.loadSwiper());
      document.addEventListener("shopify:section:load", () => this.loadSwiper());
      document.addEventListener("shopify:section:select", () => this.loadSwiper());
      document.addEventListener("shopify:section:deselect", () => this.loadSwiper());
    }
  }

  customElements.define("category-quick-links", CategoryQuickLinks);
}
